<template>
	<div class="val-container">
		
			<el-row class="mb-2" v-for="(item,index) in list">
				<el-col :span="4">
					 <com-form-uploaders  format="button" :limit="1" @change="updateData" v-model="item.image"></com-form-uploaders>
				</el-col>
				<el-col class="pl-2" :span="8">
				<el-input class="image-area" maxlength='10' show-word-limit clearable type="text" @blur="updateData" v-model='item.text'></el-input>
				</el-col>
				<el-col class="pl-2" :span="8">
					<div style="height: 148px;padding-top: 2px;">
							
						<el-button class="block" @click="addlistClick(index)" type="primary">添加</el-button>
						<el-button class="block m-0"v-if="list.length>1" @click="dellistClick(index)" type="primary">删除</el-button>
						<el-button class="block  m-0"v-if="list.length>1" @click="uplistClick(index)" type="primary">上移</el-button>
						<el-button class="block  m-0"v-if="list.length>1" @click="downlistClick(index)" type="primary">下移</el-button>
						
					</div>
					
				</el-col>
			</el-row>
			
	</div>
</template>
<script>
	export default {
		props: {
			limit: {
				type: Number,
				default: 1
			},
			
			value:{
				type:String,
				default:''
			}
		},
		data() {
			return {
				list:[{image:'',text:''}]
			}
		},
			watch: {
			    // list(newval) {
			    // 			 this.$emit('input',JSON.stringify(newval))
			    // 	     },
			    		 value(newval){
							 console.log(newval)
			    				   this.list=newval?JSON.parse( newval):[];
			    		 }
			    	   },
		methods: {
		 updateData(){
			  this.$emit('input',JSON.stringify(this.list))
		 },
			uplistClick(i) {
				if(i!=0){
				        this.list[i] = this.list.splice(i-1, 1, this.list[i])[0];
				    }else{
				        this.list.push(this.list.shift());
				    }
					 this.$emit('input',JSON.stringify(this.list))
			},
			downlistClick(i) {
				if(i!=this.list.length-1){
				        this.list[i] = this.list.splice(i+1, 1, this.list[i])[0];
				    }else{
				       this.list.unshift( this.list.splice(i,1)[0]);
				    }
					 this.$emit('input',JSON.stringify(this.list))
			},
			addlistClick(i) {
					this.list.splice(i,0,{image:'',text:''});
					 this.$emit('input',JSON.stringify(this.list))
			}, 
			dellistClick(i) {
				this.list.splice(i,1); 
				 this.$emit('input',JSON.stringify(this.list))
			},
		}
		
	}
</script>
<style >
	.btn-group-vertical {
	    position: relative;
	    display: inline-block;
	    vertical-align: middle;
	}
	.block{
		display: block;
	}
	.image-area textarea{
		height: 148px;
	}
</style>
